import React, { useMemo } from "react";
import { hostedUiBaseUrl, clientId, redirectUri, oauthScopes } from "./configAuth";
import { FaGoogle, FaFacebook, FaLinkedin } from "react-icons/fa";
import "./SocialMediaOAuth.scss";

const PROVIDER_CONFIG = {
  google: {
    cognito: "Google",
    icon: FaGoogle,
    className: "google-btn",
    label: "Google",
  },
  facebook: {
    cognito: "Facebook",
    icon: FaFacebook,
    className: "facebook-btn",
    label: "Facebook",
  },
  linkedin: {
    cognito: "LinkedIn",
    icon: FaLinkedin,
    className: "linkedin-btn",
    label: "LinkedIn",
  },
};

const buildOAuthUrl = (cognitoProviderName) => {
  if (!hostedUiBaseUrl || !clientId || !redirectUri || !cognitoProviderName) {
    return null;
  }

  const params = new URLSearchParams({
    identity_provider: cognitoProviderName,
    redirect_uri: redirectUri,
    response_type: "code",
    client_id: clientId,
    scope: oauthScopes.join(" "),
    state: Math.random().toString(36).substring(7),
    prompt: "consent",
  });

  return `${hostedUiBaseUrl}/oauth2/authorize?${params.toString()}`;
};

const SocialMediaOAuth = ({ providerName, action, setBdOpen }) => {
  const provider = useMemo(() => {
    const key = (providerName || "").toLowerCase();
    return PROVIDER_CONFIG[key] || null;
  }, [providerName]);

  const handleSSOLogin = () => {
    if (!provider) return;
    
    const loginUrl = buildOAuthUrl(provider.cognito);
    if (loginUrl) {
      window.location.href = loginUrl;
    }
  };

  if (!provider) return null;

  const Icon = provider.icon;
  const buttonText = action === "signup" 
    ? `Sign Up with ${provider.label}` 
    : `Sign In with ${provider.label}`;

  return (
    <div className="ai-signin">
      <button
        className={`ai-btn ${provider.className}`}
        onClick={handleSSOLogin}
        aria-label={buttonText}
      >
        <Icon />
        {buttonText}
      </button>
    </div>
  );
};

export default SocialMediaOAuth;